import React, {PropTypes} from "react";
import {Link} from 'react-router-dom';

class MenuItem extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    name: PropTypes.string,
    picture: PropTypes.string,
    pk: PropTypes.number,
    restaurant: PropTypes.string,
    slug: PropTypes.string,
    template: PropTypes.string
  };

  render() {
    let url = '/' + this.props.lang + '/' + this.props.restaurant + '/items/' + this.props.slug + '-' + this.props.pk;
    if(this.props.template === 'wine'){
      url = '/' + this.props.lang + '/' + this.props.restaurant + '/wine/' + this.props.slug + '-' + this.props.pk;
    }
    return (
      <Link className="menu-item"
            to={url}>
        <img src={this.props.picture}/>
        <h4 className="menu-item-title">{this.props.name}</h4>
      </Link>
    );
  }
}

export default MenuItem;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/MenuItem.js
 **/